import React from 'react';
import { Table, Tag, Typography } from 'antd';
import { audiences, clients } from '../../mockData';
import './Clients.css';

function ClientAudiences() {
  const { Title } = Typography;

  const columns = [
    { title: 'Client', key: 'client', render: (_, r) => clients.find((c) => c.id === r.clientId)?.name || '—' },
    { title: 'Audience', dataIndex: 'name', key: 'name' },
    { title: 'Size', dataIndex: 'size', key: 'size', align: 'right', render: (v) => v.toLocaleString() },
    { title: 'Type', dataIndex: 'type', key: 'type', render: (t) => <Tag>{t}</Tag> },
  ];

  return (
    <div className="agency-audience-clients">
      <Title level={3}>Client-Specific Audiences</Title>
      <Table rowKey="id" columns={columns} dataSource={audiences.clients} pagination={{ pageSize: 5 }} />
    </div>
  );
}

export default ClientAudiences;
